<template>
  <div class="flex flex-col h-auto overflow-auto relative">
    <woot-modal-header :header-title="$t('CRM_CONFIGS.ADD.TITLE')" />
    <form class="flex flex-col w-full" @submit.prevent="addCrmConfig">
      <div class="w-full">
        <woot-input
          v-model.trim="name"
          :class="{ error: $v.name.$error }"
          :error="$v.name.$error ? $t('CRM_CONFIGS.FORM.NAME.ERROR') : ''"
          :label="$t('CRM_CONFIGS.FORM.NAME.LABEL')"
          :placeholder="$t('CRM_CONFIGS.FORM.NAME.PLACEHOLDER')"
          @blur="$v.name.$touch"
        />
        <woot-input
          v-model.trim="apiLink"
          :class="{ error: $v.apiLink.$error }"
          :error="
            $v.apiLink.$error ? $t('CRM_CONFIGS.FORM.API_LINK.ERROR') : ''
          "
          :label="$t('CRM_CONFIGS.FORM.API_LINK.LABEL')"
          :placeholder="$t('CRM_CONFIGS.FORM.API_LINK.PLACEHOLDER')"
          @blur="$v.apiLink.$touch"
        />
        <woot-input
          v-model.trim="token"
          :class="{ error: $v.token.$error }"
          :error="$v.token.$error ? $t('CRM_CONFIGS.FORM.TOKEN.ERROR') : ''"
          :label="$t('CRM_CONFIGS.FORM.TOKEN.LABEL')"
          :placeholder="$t('CRM_CONFIGS.FORM.TOKEN.PLACEHOLDER')"
          @blur="$v.token.$touch"
        />
      </div>
      <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
        <woot-button class="button--clear" @click.prevent="onClose">
          {{ $t('CRM_CONFIGS.ADD.CANCEL_BUTTON_TEXT') }}
        </woot-button>
        <woot-button :is-loading="uiFlags.creatingItem">
          {{ $t('CRM_CONFIGS.FORM.SUBMIT') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  props: {
    onClose: { type: Function, default: () => {} },
  },
  data() {
    return { name: '', apiLink: '', token: '' };
  },
  validations: {
    name: { required },
    apiLink: { required },
    token: { required },
  },
  computed: {
    ...mapGetters({ uiFlags: 'crmConfigs/getUIFlags' }),
  },
  methods: {
    addCrmConfig() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store
        .dispatch('crmConfigs/create', {
          name: this.name,
          api_link: this.apiLink,
          token: this.token,
        })
        .then(() => {
          this.onClose();
          bus.$emit(
            'newToastMessage',
            this.$t('CRM_CONFIGS.ADD.API.SUCCESS_MESSAGE')
          );
        })
        .catch(() => {
          bus.$emit(
            'newToastMessage',
            this.$t('CRM_CONFIGS.ADD.API.ERROR_MESSAGE')
          );
        });
    },
  },
};
</script>
